module.exports = __webpack_public_path__ + "static/media/textsecuritydisc.1e0b333e.woff2";